/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Box, CircularProgress } from '@mui/material';
import type { ReactNode } from 'react';

export function Loader(): ReactNode {
	return (
		<Box
			sx={ {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				position: 'absolute',
				zIndex: 1,
				top: '50px',
				left: '50%',
				transform: 'translateX(-50%)'
			} }
		>
			<CircularProgress />
		</Box>
	);
}
